import { render, staticRenderFns } from "./Prematch.vue?vue&type=template&id=65dbdf1e&scoped=true&lang=pug"
import script from "./Prematch.vue?vue&type=script&lang=js"
export * from "./Prematch.vue?vue&type=script&lang=js"
import style0 from "./Prematch.vue?vue&type=style&index=0&id=65dbdf1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dbdf1e",
  null
  
)

export default component.exports